// extracted by mini-css-extract-plugin
export default {"formRow":"PostSourceForm_formRow__io5ov","checkboxesContainer":"PostSourceForm_checkboxesContainer__4J4OB"};